var filter = {};
var searchTerm = "";

//Staffbase bug when scrolling to top
var scrollToTop = false;

$(window).on('load', function(){
    var $grid = $('.grid').isotope({
        itemSelector: '.discount-itembox',
        layoutMode: 'fitRows'
    });


    var haveDataToLoad = false;
    if(window.location.hash) {
        var hash = window.location.hash.substring(1);
        if(hash == 'all') {
            saveFilters(true);
        } else {
            haveDataToLoad = true;
            $('#filteroptions .optionbox.category a[data-filter="'+ hash +'"]').addClass('active');
        }
    }

    //load filters from cookies
    if(!haveDataToLoad && $('.filter').length) {
        var loadedFilter = Cookies.get('filter');
        var loadedSearchTerm = Cookies.get('searchTerm');

        if(loadedFilter) {
            filter = JSON.parse(loadedFilter);
            haveDataToLoad = true;
        }
        if(haveDataToLoad)
            loadFilters(filter);
    }

    if(haveDataToLoad) {
        saveFilters(false);
        generateActiveFilters();
        reloadFilters();
    }


    //removing active filters
    $('#activefilters').on( 'click', 'a', function(e) {
        e.preventDefault();

        if($(this).hasClass('basic')) {
            var filterData = $(this).data('filter');

            $('#filteroptions .optionbox a[data-filter="'+ filterData +'"]').removeClass('active');
            $(this).remove();
        }

        saveFilters(true);
        reloadFilters();
    });

    /*
     *  open filters screen
     */
    $('#openfilter').on( 'click', function(e) {
        e.preventDefault();

        if(!$('#filteroptions').hasClass('active')) {
            $('#filteroptions').addClass('active');
        }

        if(scrollToTop)
            $('html, body').animate({
                scrollTop: 0
            }, 100);
    });

    /*
     *  apply filter button click on filter screen
     */
    $('#applyFilter').on( 'click', function(e) {
        e.preventDefault();

        $('#filteroptions').removeClass('active');

        saveFilters(true);
        generateActiveFilters();
        reloadFilters();

        if(scrollToTop)
            $('html, body').animate({
                scrollTop: 0
            }, 100);
    });

    /*
     * fix for not working zoom on Androids in Staffbase
     */
    $('#zoom').on( 'click', function(e) {
        e.preventDefault();

        if($('.imagecontainer').hasClass('zoomed'))
            $('.imagecontainer').removeClass('zoomed');
        else
            $('.imagecontainer').addClass('zoomed');
    });

    //filters options
    $('#filteroptions .optionbox a').on('click', function(e) {
        e.preventDefault();

        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }
        else {
            if($(this).parents('.sort').length){
                $(this).parents('.sort').find('a').removeClass('active');
            }
            $(this).addClass('active');
        }
    });

    function loadFilters(filters) {
        if(filters && 'category' in filters) {
            for (var i = 0; i < filters.category.length; i++) {
                $('#filteroptions .optionbox.category a[data-filter="'+ filters.category[i].value +'"]').addClass('active');
            }
        }
    }

    function saveFilters(track) {
        filter = {};
        filter.category = [];

        var trackData = {}; trackData.category = []; trackData.fullFilter = "";

        $('#filteroptions .optionbox.category a.active').each(function() {
            filter.category.push({value: $(this).data('filter'), title: $(this).text()});
            trackData.category.push($(this).text());
        });

        if( typeof gtag !== "undefined" ) {
            if(trackData.category.length > 0){
                gtag('event', 'filterCategory', {
                    'event_category': 'filter',
                    'event_label': trackData.category.toString()
                });

                trackData.fullFilter = ' |CATEGORY - ' + trackData.category.toString() + '|';
            }

            gtag('event', 'filterAll', {
                'event_category': 'filter',
                'event_label': trackData.fullFilter
            });
        }

        //save to cookies
        Cookies.set('filter', JSON.stringify(filter), { expires: 7 });
        //TODO cookies search
    }

    //reload items in Grid
    function reloadFilters() {
        $grid.isotope({
            filter: function() {
                var item = $(this);
                var itemResultCategory = _reloadFilterResult(item, filter.category);

                return itemResultCategory;
            }
        })
    }

    function _reloadFilterResult(item, filterArray){
        var itemResult = false;
        if(filterArray.length>0){
            for (var i = 0; i < filterArray.length; i++) {
                if(item.hasClass(filterArray[i].value))
                    itemResult = true;
            }
        }else
            itemResult = true;

        return itemResult;
    }

    function generateActiveFilters() {
        $('#activefilters').html('');
        _generateActiveFilter(filter.category);
    }

    function _generateActiveFilter(filterArray){
        if(filterArray.length>0){
            for (var i = 0; i < filterArray.length; i++) {
                $('#activefilters').append(_generateActiveFilterLink(filterArray[i].value,filterArray[i].title));
            }
        }
    }

    function _generateActiveFilterLink(value, title) {
        return '<a href="#" data-filter="' + value + '" class="btn btn-vw-icon basic"><span class="favw vw-x"></span> ' + title + '</a>'
    }

    function numberWithSpaces(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    //search
    var lastSearch = "";

    function sendGASearchEvent(searchTerm) {
        if(searchTerm == lastSearch && typeof gtag !== "undefined") {
            gtag('event', 'search', {
                'search_term': searchTerm
            });
        }
    }

    $( ".searchform .itemsearch input" ).on( "change keyup input", function(e) {
        if(lastSearch !=$(this).val()) {
            lastSearch = $(this).val();
            var searchText = $(this).val();
            var box = $(this).parents(".searchform");
            var dataToSend = {text: $(this).val()};
            var url = box.data("url");


            if($(this).val().length>2) {
                setTimeout(function() { sendGASearchEvent(searchText) }, 2000);
            }


            $.post(url, dataToSend, function(data) {
                if(data["status"]=="OK"){
                    $('body').addClass("with-search-results");
                    $('#searchresults').html(data["html"]);
                }else{
                    $('body').removeClass("with-search-results");
                }
            }, "json").fail(function(error){
                var data = error.responseJSON;
                if(data.status=="ERROR" && data.errors){
                    $('body').removeClass("with-search-results");
                }else{
                    $('body').removeClass("with-search-results");
                }
            });
        }
    });

    $( ".searchform .itembutton .btn" ).on( "click", function(e) {
        e.preventDefault();
    });

    /*
     *  open search screen
     */
    $('#opensearch').on( 'click', function(e) {
        e.preventDefault();

        $('body').addClass('discount-search-screen');
        $('#search').focus();

        if(scrollToTop)
            $('html, body').animate({
                scrollTop: 0
            }, 100);
    });

    /*
     *  close search screen
     */
    $('#closesearch').on( 'click', function(e) {
        e.preventDefault();
        $('body').removeClass('discount-search-screen');
    });

});

